let server = "https://infinity.leonisa.com/webstore-service-embajadoras";
let emb_expireDays = "15";
let shopifyId = Shopify.shop;
let parameters;
var referido_por_id;
var referido_por;
let refresh = false;

window.addEventListener('load', function () {
  parameters = getQueryParams();

  let is_referred = isReferred();
  console.log(referido_por_id);

  if (is_referred) {
    $("#is_referred").val("true");
    $("#IsLevelOrder").val("true");
    $("#referido_por_id").val(referido_por_id);
    $("#referido_por").val(referido_por);
    $("#referido_content").show();

    jQuery.post(window.Shopify.routes.root + 'cart/update.js', "attributes[IsReferred]=true");
    jQuery.post(window.Shopify.routes.root + 'cart/update.js', "attributes[IsLevelOrder]=true");
    jQuery.post(window.Shopify.routes.root + 'cart/update.js', "attributes[referido_por_id]=" + referido_por_id);
    jQuery.post(window.Shopify.routes.root + 'cart/update.js', "attributes[referido_por]=" + referido_por);

    if (refresh) {
      window.location.reload();
    }
  }
  else {
    jQuery.post(window.Shopify.routes.root + 'cart/update.js', "attributes[IsReferred]=");
    jQuery.post(window.Shopify.routes.root + 'cart/update.js', "attributes[IsLevelOrder]=");
    jQuery.post(window.Shopify.routes.root + 'cart/update.js', "attributes[referido_por_id]=");
    jQuery.post(window.Shopify.routes.root + 'cart/update.js', "attributes[referido_por]=");
    
  }
  
});

function isReferred() {
  let customer_id = $("#customer_id").val();
  let isEmbajador = $("#isEmbajador").val();

  referido_por_id = getCookie("referido_por_id");
  referido_por = getCookie("referido_por");

  if (parameters.embajador) {
    if (referido_por_id == null || referido_por_id == "") {
      refresh = true;
    }

    referido_por_id = parameters.embajador;
    setCookie("referido_por_id", parameters.embajador, emb_expireDays);

    setCustomerInfo();
  }

  if ((referido_por_id != null && referido_por_id == customer_id) || isEmbajador == "true") {
    removeCookie("referido_por_id");
    removeCookie("referido_por");
    referido_por_id = null;
    referido_por = null;
  }

  return referido_por_id != null && referido_por_id != "";
}

function getQueryParams() {
  qs = document.location.search;
  qs = qs.split('+').join(' ');

  let params = {},
    tokens,
    re = /[?&]?([^=]+)=([^&]*)/g;

  while (tokens = re.exec(qs)) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }

  return params;
};

function setCookie(name, value, days) {
  let expires = "";

  if (days) {
    let date = new Date();

    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }

  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  let nameEQ = name + "=";
  let ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];

    while (c.charAt(0) == ' ') c = c.substring(1, c.length);

    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }

  return null;
}

function removeCookie(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function setCustomerInfo() {
  $.ajax({
    url: server + "/api/Customer/GetReferredInfo/" + shopifyId + "/" + referido_por_id,
    type: "GET",
    contentType: "application/json;charset=utf-8",
    success: function (data) {
      console.log(data);

      if (data != null) {
        setCookie("referido_por", data.name, emb_expireDays);
        referido_por = data.name;
        $("#referido_por").val(referido_por);
      }
    },
    error: function (msg) {
      console.log(msg);
    }
  });
}